export const SCROLL_SECTION = 'products-differences__columns';
